
import React from 'react';
import { TableBody } from '@/components/ui/table';
import { ItineraryEvent } from '@/types/itinerary';
import { TransportationTableRow } from './TransportationTableRow';

interface TransportationBodyProps {
  events: ItineraryEvent[];
}

export const TransportationBody: React.FC<TransportationBodyProps> = ({ events }) => {
  return (
    <TableBody>
      {events.map((event) => (
        <TransportationTableRow key={event.id} event={event} />
      ))}
    </TableBody>
  );
};
